export default __webpack_public_path__ + "static/media/social-media-facebook.f3ad34b1.svg";